<script>
import pdf from "vue-pdf";

export default {
  name: "PdfViewer",
  components: { pdf },
  props: {
    pdfUrl: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      // pdfUrl: null,
      numPages: 0,
      visiblePages: {},
      loadedPages: {},
      observers: [],
    };
  },
  methods: {
    onFileChange(e) {
      const file = e.target.files[0];
      if (file) {
        this.pdfUrl = URL.createObjectURL(file);
        this.numPages = 0;
        this.visiblePages = {};
        this.loadedPages = {};
        this.cleanupObservers();
      }
    },
    onNumPages(n) {
      this.numPages = n;
      this.$nextTick(() => {
        this.setupObservers();
      });
    },
    setupObservers() {
      this.cleanupObservers();
      const root = this.$refs.scrollContainer;
      if (!root) return;

      for (let page = 1; page <= this.numPages; page++) {
        const el = this.$refs[`page-${page}`]?.[0];
        if (!el) continue;

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const page = parseInt(entry.target.dataset.page);
              if (entry.isIntersecting) {
                // When page becomes visible, mark it as loaded and visible
                this.$set(this.visiblePages, page, true);
                this.$set(this.loadedPages, page, true);
              } else {
                // When page is hidden, only update visibility
                this.$delete(this.visiblePages, page);
                // Keep it in loadedPages - don't remove
              }
            });
          },
          { root, threshold: 0.1 }
        );
        observer.observe(el);
        this.observers.push(observer);
      }
    },
    cleanupObservers() {
      this.observers.forEach((o) => o.disconnect());
      this.observers = [];
    },
  },
  beforeDestroy() {
    this.cleanupObservers();
  },
};
</script>

<template>
  <div
    class="fixed inset-0 flex items-center justify-center bg-slate-800/50 z-50"
  >
    <div
      class="bg-white dark:bg-slate-800 max-h-[80vh] overflow-y-auto rounded-lg p-6 shadow-lg min-w-[48rem] border border-slate-200 dark:border-slate-700"
      ref="scrollContainer"
    >
      <!-- header -->
      <div class="flex items-center mb-4 justify-between">
        <h1 class="text-xl font-bold">PDF Viewer</h1>
        <woot-button
          variant="clear"
          color-scheme="alert"
          icon="dismiss"
          @click="$emit('close')"
        />
      </div>

      <!-- <input type="file" accept="application/pdf" @change="onFileChange" /> -->

      <div v-if="pdfUrl">
        <!-- hidden loader to detect total pages -->
        <pdf :src="pdfUrl" style="display: none" @num-pages="onNumPages" />

        <!-- placeholder + lazy page rendering -->
        <div
          v-for="page in numPages"
          :key="page"
          :ref="`page-${page}`"
          :data-page="page"
          class="mb-4"
          style="min-height: 400px;"
        >
          <pdf
            v-if="loadedPages[page]"
            :src="pdfUrl"
            :page="page"
            style="border: 1px solid #ddd; width: 100%;"
          />
          <div
            v-else
            class="h-[400px] flex items-center justify-center bg-slate-100 text-slate-500"
          >
            Loading page {{ page }}…
          </div>
        </div>
      </div>

      <p v-else>Please upload a PDF</p>
    </div>
  </div>
</template>
